// import LanguageSelect from "@/components/Language/LanguageSelect";
import { Box, styled, useTheme } from "@mui/material";
import MobileLanguageSelector from "@/pages/components/MobileLanguageSelector";
import {useBoolean} from "ahooks";
import RpIcon from "@/components/RpIcon";
// import UserAvatar from "@/pages/components/UserAvatar";

const StyledHeader = styled(Box)(({}) => ({
  textAlign: 'center',
  position: 'relative',
  padding: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent:'space-between',
  'img': {
    height: '26px',
  },
}))

function LogoHeader({ leading, right, showLanguageSelector }) {
  const theme = useTheme();
  const [isLanguageSelectorOpen, languageSelectorOperate] = useBoolean(false);
  
  return (<>
    <StyledHeader>
      {leading}
      <Box sx={{
        flex: 1,
        display: 'flex',
        justifyContent: leading ? 'center' : 'flex-start',
      }}>
        {/* <img src={theme.palette.mode == 'light' ? '/images/logo-light.svg' : '/images/logo-dark.png'}/> */}
        <img src={'/images/logo-sonic-dark.png'}/>
      </Box>


      {/*<UserAvatar size={48} fontSize={24} nationSize={18} />*/}
      {right}
      { showLanguageSelector && <RpIcon icon="lang" clickable size={22} onClick={() => {languageSelectorOperate.setTrue()}}/> }
    </StyledHeader>
    <MobileLanguageSelector
      open={isLanguageSelectorOpen}
      onClose={languageSelectorOperate.setFalse}
    />
  </>
  );
}

export default LogoHeader;
